import img from "../img_us/10Claustra décoratif architectural intérieur – séparation design et protection solaire Unik System Maroc.webp";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsFilmDecoratifPage() {

  useEffect(() => {
    // Animation
    AOS.init({
      duration: 1500,
      once: true,
    });

   
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>FILM</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Films décoratifs pour vitrages</h1>

          <p data-aos="fade-up">
            Solutions décoratives pour personnaliser les vitrages tout en
            conservant la luminosité naturelle. Les films décoratifs
            apportent intimité, design et protection durable.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-film-decoratif.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Film décoratif vitrage" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US FILM Décoratif ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US FILM Décoratif est une solution esthétique pour habiller
            les vitrages. Fabriqués à partir d’un polyester évolué,
            ces films sont résistants et durables.
          </p>

          <p data-aos="fade-up">
            Ils permettent de préserver l’intimité, améliorer le design
            des espaces et apporter une finition moderne aux vitrages
            sans réduire la luminosité.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="🎨"
            title="Design personnalisé"
            text="Large choix de finitions, motifs et textures."
          />
          <Feature
            icon="😎"
            title="Préservation de l’intimité"
            text="Protège des regards tout en laissant passer la lumière."
          />
          <Feature
            icon="✨"
            title="Aspect moderne"
            text="Apporte une finition élégante aux vitrages."
          />
          <Feature
            icon="🛡️"
            title="Protection du vitrage"
            text="Renforce le verre et évite les éclats."
          />
          <Feature
            icon="💡"
            title="Luminosité conservée"
            text="Diffuse la lumière naturelle dans les espaces."
          />
          <Feature
            icon="⚡"
            title="Installation rapide"
            text="Pose simple sans travaux lourds."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Film polyester évolué</li>
          <li>Finitions décoratives variées</li>
          <li>Résistance à la décoloration</li>
          <li>Traitement anti-rayures</li>
          <li>Protection contre les UV</li>
          <li>Application sur vitrages existants</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Bureaux",
            "Salles de réunion",
            "Commerces",
            "Hôtels",
            "Habitations",
            "Vitrines",
            "Espaces publics",
            "Cloisons vitrées",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Envie de personnaliser vos vitrages ?</h2>
        <p>Nos équipes vous accompagnent dans votre projet.</p><br/>
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
